export default {
  velt: {
    openPanel: 'เปิดแผงความคิดเห็น',
    closePanel: 'ปิดแผงความคิดเห็น',
    panel: 'แผงความคิดเห็น',
    tabs: 'แท็บแผงความคิดเห็น',
    comments: 'ความคิดเห็น',
    settings: 'การตั้งค่าและสิทธิ์',
    dragOrTapComment: 'ลากเพื่อเพิ่มความคิดเห็น หรือแตะเพื่อดูความคิดเห็น',
    assignComment: 'มอบหมายความคิดเห็น',
    markAsUnread: 'ทำเครื่องหมายว่ายังไม่ได้อ่าน',
    markAsRead: 'ทำเครื่องหมายว่าอ่านแล้ว',
    unsubscribe: 'ยกเลิกการติดตาม',
    subscribe: 'ติดตาม',
    deleteThread: 'ลบเธรด',
    editComment: 'แก้ไขความคิดเห็น',
    emptyPlaceholder: 'ให้ข้อเสนอแนะ ถามคำถาม หรือฝากข้อความถึงสมาชิกในทีมของคุณ',
    searchPlaceholder: 'ค้นหาความคิดเห็น',
    commentPlaceholder: 'แสดงความคิดเห็นใน {page}',
    replyPlaceholder: 'ตอบกลับ....',
    filterPages: 'หน้า',
    filterAuthor: 'ผู้เขียน',
    filterTagged: 'ที่ถูกแท็ก',
    statusOpen: 'เปิด',
    statusResolved: 'แก้ไขแล้ว',
    anonymous: 'ไม่ระบุชื่อ',
    settingsPanel: {
      title: 'ใครสามารถแสดงความคิดเห็นได้บ้าง?',
      everyoneLabel: 'ทุกคน',
      restrictedLabel: 'เฉพาะผู้ร่วมงานที่ได้รับเชิญ',
      emailsLabel: 'อีเมล',
      emailsPlaceholder: 'เพิ่มอีเมลแล้วกด Enter',
    },
  },
}
